import { ValueProvider } from '@juvare/common-form-ui/ValueProvider';
import { PublicSettings, Settings } from '@juvare/platform-sdk-react/types';

export function useCategoryValueProvider(settings: Settings | PublicSettings): ValueProvider {
    return {
        type: 'category',
        label: 'Category',
        getValues: () => {
            return new Promise((resolve) => {
                const categories = settings.notificationCategoryList.map((pc) => ({
                    value: pc.category.key,
                    label: `${pc.category.key}. ${pc.category.value}`,
                }));
                resolve(categories);
            });
        },
    };
}
